import * as React from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../redux/actions";
import "../../css/UnitCopyModal.scss";
import { basisOfDesignOptions, normalizeBasisOfDesign } from "../../utilities/basisOfDesignOptions";
// expected props
interface IProps {
  updateRedux: any;
  reduxModals: any;
  reduxProjectManagement: any;
}
// local state
interface IState {
  designBasis:string;
  userVerified:boolean;
}

class SubmittalReleaseModal extends React.Component<IProps, IState> {
  public state: IState = { designBasis:"", userVerified:false};

  //This is a specific modal for copying a unit to the project selected by the user.
  componentDidMount() {
    this.setState({designBasis: normalizeBasisOfDesign(this.props.reduxProjectManagement.selectedProject.designBasis)});
  }
  public render() {
    let disabled = this.state.userVerified === false || this.state.designBasis === "" ? "disabledDiv" : "";

    return (
      <div className="submitRelease">
        <div className="header">Confirm Release Request</div>


        <p className="submittal-release-paragraph">By submitting this request, the selected unit(s) will be released to production based on the recent submittal designs. 
                Any changes after release will be subject to a change order fee.</p>
        <p className="submittal-release-paragraph">Any unit(s) not selected within this request will be changed to an inactive status and not released.</p>

        <div className="release-input-row">
            <div className="release-request-label">Basis of Design</div>
            <div className="release-dropdown">
            <select className="release-select" value={this.state.designBasis} onChange={(event) => this.setState({ designBasis: event.currentTarget.value })}>
                {basisOfDesignOptions.map((option) => <option key={option} value={option}>{option}</option>)}
            </select>
            </div>
        </div>

        <div>
            <div className="release-checkbox">
              <input
                type="checkbox"
                checked={this.state.userVerified}
                onChange={(event) => this.setState({userVerified: event.currentTarget.checked})}
              />
            </div>
            <div className="checkbox-input-label-release">I have verified the selected Basis of Design</div>
          </div>

        <div className="release-button-container">
          <div className={"release-ok-btn " + disabled} onClick={() => this.userResponse("ok")}>
            Ok
          </div>
          <div className="proj-cancel-btn" onClick={() => this.userResponse("cancel")}>
            Cancel
          </div>
        </div>
      </div>
    );
  }
  private userResponse(response: string) {
    let submitReleaseResponse = {
      response: response,
      designBasis:this.state.designBasis
    };
    //This will trigger the componentDidUpdate method on Release.tsx
    this.props.updateRedux("UPDATE_MODALS", { showModal: false, userResponse: submitReleaseResponse });
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
    reduxProjectManagement: state.reduxProjectManagement,
    reduxModals: state.reduxModals
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SubmittalReleaseModal);
